import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importando os arquivos de tradução
import en from "./locales/en.json"; // Traduções gerais
import pt from "./locales/pt.json"; // Traduções gerais
import enPedidoOracao from "./locales/en_pedido_oracao.json"; // Traduções específicas do Pedido de Oração
import ptPedidoOracao from "./locales/pt_pedido_oracao.json"; // Traduções específicas do Pedido de Oração
import enTestemunho from "./locales/en_testemunho.json"; // Traduções específicas do Testemunho
import ptTestemunho from "./locales/pt_testemunho.json"; // Traduções específicas do Testemunho
import enInscricaoEvento from "./locales/en_inscricao_evento.json"; // Traduções da tela Inscrição para Evento
import ptInscricaoEvento from "./locales/pt_inscricao_evento.json";
import salon0 from "./locales/salon/pt-BR.json";
import salon1 from "./locales/salon/pt-PT.json";
import salon2 from "./locales/salon/en-US.json";
import salon3 from "./locales/salon/es-ES.json";
import salon4 from "./locales/salon/fr-FR.json"; // Traduções da tela Inscrição para Evento

i18n
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Inicializa o react-i18next
  .init({
    resources: {
      "pt-BR": { translation: pt, salon: salon0, pedido_oracao: ptPedidoOracao, testemunho: ptTestemunho, inscricao_evento: ptInscricaoEvento },
      "pt-PT": { translation: pt, salon: salon1, pedido_oracao: ptPedidoOracao, testemunho: ptTestemunho, inscricao_evento: ptInscricaoEvento },
      "en-US": { translation: en, salon: salon2, pedido_oracao: enPedidoOracao, testemunho: enTestemunho, inscricao_evento: enInscricaoEvento },
      "es-ES": { translation: pt, salon: salon3, pedido_oracao: ptPedidoOracao, testemunho: ptTestemunho, inscricao_evento: ptInscricaoEvento },
      "fr-FR": { translation: pt, salon: salon4, pedido_oracao: ptPedidoOracao, testemunho: ptTestemunho, inscricao_evento: ptInscricaoEvento },
    },
    supportedLngs: ["pt-BR", "pt-PT", "en-US", "es-ES", "fr-FR"],
    nonExplicitSupportedLngs: false,
    fallbackLng: "pt-BR",
    load: "currentOnly",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "gestor.locale",
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => {
        const x = String(lng || "").toLowerCase();
        if (x.startsWith("pt-pt")) return "pt-PT";
        if (x.startsWith("pt")) return "pt-BR";
        if (x.startsWith("en")) return "en-US";
        if (x.startsWith("es")) return "es-ES";
        if (x.startsWith("fr")) return "fr-FR";
        return "pt-BR";
      },
    },
    ns: ["translation", "salon", "pedido_oracao", "testemunho", "inscricao_evento"],
    defaultNS: "translation",
    react: { useSuspense: false },
    interpolation: {
      escapeValue: false, // React já protege contra XSS
    },
  });

// HTML lang favorece leitores de ecrã, teclado e ferramentas de acessibilidade.
if (typeof document !== "undefined") {
  const syncDocumentLanguage = (lng) => {
    const selected = String(lng || i18n.resolvedLanguage || "pt-BR");
    document.documentElement.lang = selected;
  };
  syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);
  i18n.on("languageChanged", syncDocumentLanguage);
}

export default i18n;
